export const queryKeys = {
  COMPOSERS: "get-composers",
  LANGUAGES: "get-languages",
  CATEGORIES: "get-categories",
};
